import moment from 'moment';

const globalFunc = {
  clearComponentCache: (param)=> {
    const component = param.matched[0].instances.default;

    if (component && component.$vnode && component.$vnode.data.keepAlive) {
      if (component.$vnode.parent && component.$vnode.parent.componentInstance && component.$vnode.parent.componentInstance.cache) {
        if (component.$vnode.componentOptions) {
          var key = component.$vnode.key == null
            ? component.$vnode.componentOptions.Ctor.cid + (component.$vnode.componentOptions.tag ? `::${component.$vnode.componentOptions.tag}` : '')
            : component.$vnode.key;
          var cache = component.$vnode.parent.componentInstance.cache;
          var keys = component.$vnode.parent.componentInstance.keys;
          if (cache[key]) {
            if (keys.length) {
              var index = keys.indexOf(key);
              if (index > -1) {
                keys.splice(index, 1);
              }
            }
            delete cache[key];
          }
        }
      }
    }
  },
  stringToDate(date) {
    return moment(date, 'YYYY-MM-DD');
  },
  stringToDatetime(date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss')
  },
  dateToString(date) {
    return moment(date).format('YYYY-MM-DD');
  },
  dateTimeToString(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  },
  dateStringAddDays(date, day) {
    return moment(date).add(day, 'days').format('YYYY-MM-DD')
  },
  curDateString() {
    return moment().format('YYYY-MM-DD')
  },
  curDateTimeString() {
    return moment().format('YYYY-MM-DD HH:mm:ss');
  },
  curDateStringAddDays(day) {
    return moment().add(day, 'days').format('YYYY-MM-DD')
  },
  dateStringAddMonths(date, months) {
    return moment(date).add(months, 'months').format('YYYY-MM-DD')
  },
  getWeekdayString(weekday) {
    switch(weekday) {
      case 0:
        return '일요일';
      case 1:
        return '월요일';
      case 2:
        return '화요일';
      case 3:
        return '수요일';
      case 4:
        return '목요일';
      case 5:
        return '금요일';
      case 6:
        return '토요일';
    }
  },
  gender(gender, flag) {
    if(flag) {
      return gender === 'M' ? '남' : '여';
    }
    return gender === 'M' ? '남자' : '여자';
  },
  formatCustomerName(item) {
    if (item.state === 'Disable') {
      return `- \r\n (${item.name})`
    } else {
      return item.name
    }
  },
  getImgUrl(photoUrl) {
    return process.env.VUE_APP_API_HOST + photoUrl;
  },
  getExcelUrl(excelUrl) {
    return process.env.VUE_APP_EXCEL_HOST + excelUrl + "?t=" + new Date().getTime();
  },
  activeStatus(text) {
    if(text === 'Enable') {
      return '활성';
    } else if(text ==='Disable'){
      return '비활성';
    } else  if(text === 'Expired'){
      return '만료';
    } else {
      return '-';

    }
  },
  msToTimeFormat(data) {
    return moment().set({hours: 0, minutes: 0, seconds: 0}).add(data, 'ms').format('HH시간 mm분 ss초');
  },
  formatSecToTime(sec) {
    let hours = Math.floor(sec / 3600);
    let minutes = Math.floor((sec - (hours * 3600)) / 60);
    let seconds = sec % 60;

    if (hours > 0) {
      return `${hours}시간 ${minutes}분 ${seconds}초`
    } else {
      return `${minutes}분 ${seconds}초`
    }
  },
  secToTimeFormat(data) {
    return moment().startOf('day').seconds(data).format('HH시간 mm분 ss초');
  },
  secToTimeFormat2(data) {
    const hours = Math.floor(data / 3600);
    const minutes = Math.floor(data / 60 % 60);
    return `${hours < 10 ? '0' + hours : hours}시간 ${minutes < 10 ? '0' + minutes : minutes}분`;
  },
  toFormatTime: (value) => {
    const totalMin = Math.floor(value / 60);
    if (totalMin < 60) {
      return totalMin + " 분";
    } else {
      const hours = Math.floor(totalMin / 60);
      const min = totalMin % (hours * 60);

      return `${hours}시간 ${min}분`;
    }
  },
  mainDistrict() {
    return [
      {text : '서울특별시', value:'Seoul'},
      {text : '부산광역시', value:'Busan'},
      {text : '인천광역시', value:'Incheon'},
      {text : '대구광역시', value:'Daegu'},
      {text : '광주광역시', value:'Gwangju'},
      {text : '대전광역시', value:'Daejeon'},
      {text : '울산광역시', value:'Ulsan'},
      {text : '세종특별자치시', value:'Sejong'},
      {text : '경기도', value:'Gyeonggi'},
      {text : '강원도', value:'Gangwon'},
      {text : '충청북도', value:'Chungbuk'},
      {text : '충청남도', value:'Chungnam'},
      {text : '경상북도', value:'Kyeongbuk'},
      {text : '경상남도', value:'Kyeongnam'},
      {text : '전라북도', value:'Jeonbuk'},
      {text : '전라남도', value:'Jeonnam'},
      {text : '제주특별자치도', value:'Jeju'},
    ]
  },

  subDistrict(value) {
    let subD = [];
    switch (value) {
      case 'Seoul' :
        subD = ['종로구', '중구', '용산구', '성동구', '광진구', '동대문구', '중랑구', '성북구', '강북구', '도봉구', '노원구',
          '은평구', '서대문구', '마포구', '양천구', '강서구', '구로구', '금천구', '영등포구', '동작구', '관악구', '서초구',
          '강남구', '송파구', '강동구'];
        break;
      case 'Busan' :
        subD = ['중구', '서구', '동구', '영도구', '부산진구', '동래구', '남구', '북구', '강서구', '해운대구', '사하구', '금정구',
          '연제구', '수영구', '사상구', '기장군'];
        break;
      case 'Incheon':
        subD = ['중구', '동구', '남구', '연수구', '남동구', '부평구', '계양구', '서구', '강화군', '옹진군'];
        break;
      case 'Daegu':
        subD = ['중구', '동구', '서구', '남구', '북구', '수성구', '달서구', '달성군'];
        break;
      case 'Gwangju':
        subD = ['동구', '서구', '남구', '북구', '광산구'];
        break;
      case 'Daejeon':
        subD = ['동구', '중구', '서구', '유성구', '대덕구'];
        break;
      case 'Ulsan':
        subD = ['중구', '남구', '동구', '북구', '울주군'];
        break;
      case 'Gyeonggi':
        subD = ['가평군', '고양시', '과천시', '광명시', '광주시', '구리시', '군포시', '김포시', '남양주시',
          '동두천시', '부천시', '성남시', '수원시', '시흥시', '안산시', '안성시', '안양시', '양주시', '양평군', '여주시',
          '연천군', '오산시', '용인시', '의왕시', '의정부시', '이천시', '파주시', '평택시', '포천시', '하남시', '화성시'];
        break;
      case 'Gangwon':
        subD = ['원주시', '춘천시', '강릉시', '동해시', '속초시', '삼척시', '홍천군', '태백시', '철원군', '횡성군', '평창군',
          '영월군', '정선군', '인제군', '고성군', '양양군', '화천군', '양구군'];
        break;
      case 'Chungbuk':
        subD = ['청주시', '충주시', '제천시', '보은군', '옥천군', '영동군', '증평군', '진천군', '괴산군', '음성군', '단양군'];
        break;
      case 'Chungnam':
        subD = ['천안시', '공주시', '보령시', '아산시', '서산시', '논산시', '계룡시', '당진시', '금산군', '부여군', '서천군',
          '청양군', '홍성군', '예산군', '태안군'];
        break;
      case 'Kyeongbuk':
        subD = ['포항시', '경주시', '김천시', '안동시', '구미시', '영주시', '영천시', '상주시', '문경시', '경산시', '군위군',
          '의성군', '청송군', '영양군', '영덕군', '청도군', '고령군', '성주군', '칠곡군', '예천군', '봉화군', '울진군', '울릉군'];
        break;
      case 'Kyeongnam':
        subD = ['창원시', '김해시', '진주시', '양산시', '거제시', '통영시', '사천시', '밀양시', '함안군', '거창군', '창녕군',
          '고성군', '하동군', '합천군', '남해군', '함양군', '산청군', '의령군'];
        break;
      case 'Jeonbuk':
        subD = ['전주시', '익산시', '군산시', '정읍시', '완주군', '김제시', '남원시', '고창군', '부안군', '임실군', '순창군',
          '진안군', '장수군', '무주군'];
        break;
      case 'Jeonnam':
        subD = ['여수시', '순천시', '목포시', '광양시', '나주시', '무안군', '해남군', '고흥군', '화순군', '영암군', '영광군',
          '완도군', '담양군', '장성군', '보성군', '신안군', '장흥군', '강진군', '함평군', '진도군', '곡성군', '구례군'];
        break;
      case 'Jeju':
        subD = ['제주시', '서귀포시'];
        break;
      case 'Sejong':
        subD = ['세종시'];
        break;
    }
    return subD;
  },

  initObjectData(inputObject, defaultObject) {
    let obj = {};

    for(const key in inputObject) {
      let value = inputObject[key];
      const isExistDefault = !!defaultObject[key];
      const isObject = typeof(value) ==='object' && !Array.isArray(value);

      if(isObject && isExistDefault) {
        //object에 default value 가 있는경우
        obj[key] = this.initObjectData(value, defaultObject[key]);
      } else if(isExistDefault) {
        //object가 아니지만 default value가 있는경우(primitive type || array)
        obj[key] = defaultObject[key];
      } else {
        // default가 없는경우
        obj[key] = this.setDefaultByType(value);
      }
    }
    return obj;
  },

  setDefaultByType(value) {
    const valueType = typeof value;
    if(value === null || valueType==='undefined') {
      if(valueType==='undefined') {
        return undefined;
      } else {
        return null;
      }
    } else if(valueType === 'boolean') {
      return false;
    } else if(valueType === 'number') {
      return 0;
    } else if(valueType === 'string') {
      return '';
    }else if(valueType ==='object' && Array.isArray(value)) {
      return [];
    }else {
      return {};
    }
  },

  numberFormatter(value) {
    const formatted = Number(value).toLocaleString();
    if(formatted === 'NaN') {
      return 0;
    }
    return formatted;
  },

  displayCustomerType(type) {
    const typeValue = type.configValue;
    if (!typeValue) return '-';

    if (typeValue === 'ct_normal' || typeValue === 'ct_guardian') {
      return type.configName;
    } else {
      return '교통약자 (' + type.configName + ')';
    }
  },

  displayWeakCustomerInfo(mobilityWeakInfo, pregnantInfo) {
    let text;
    if(!mobilityWeakInfo && !pregnantInfo) {
      text= '-'
    } else if (mobilityWeakInfo) {
      text= ''
      const {handicapInfo, wheelchair} = mobilityWeakInfo;
      const handicapArr = JSON.parse(handicapInfo);
      text = handicapArr.map(handicap => {
        const {type, degree} = handicap;
        return type+'('+degree+')';
      }).join();

      if (wheelchair !== '없음') {
        text += '/' + wheelchair + "휠체어";
      }
    } else {
      text= pregnantInfo.expectedDeliveryDate + ' 출산예정';
    }
    return text;
  },
  displayPassengerType(type) {
    return type === 'BOOKER'? '예약자': type==='FELLOW' ? '동승자': '미예약자';
  },

  meterToKilometer(meterVal) {
    if (!meterVal || meterVal < 0) return 0;
    return Number(meterVal / 1000).toLocaleString();
  },

  clearSessionStorage() {
    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem('refreshToken');
  }
};
export default globalFunc;
